import React from 'react';
import { SOCIAL_MEDIA_CONFIG, logOAuthConfig } from '../../config/socialMediaConfig';

export const OAuthDebug: React.FC = () => {
  const origin = window.location.origin;
  const redirectUri = SOCIAL_MEDIA_CONFIG.facebook.redirectUri;
  
  React.useEffect(() => {
    logOAuthConfig();
  }, []);

  return (
    <div style={{ 
      padding: '2rem', 
      backgroundColor: '#f8f9fa', 
      border: '1px solid #dee2e6', 
      borderRadius: '8px',
      fontFamily: 'monospace',
      fontSize: '14px',
      margin: '1rem'
    }}>
      <h3 style={{ color: '#495057', marginTop: 0 }}>[DEBUG] Facebook OAuth Debug Information</h3>
      
      <div style={{ marginBottom: '1rem' }}>
        <strong>Current Environment:</strong>
        <ul>
          <li><strong>Origin:</strong> {origin}</li>
          <li><strong>Hostname:</strong> {window.location.hostname}</li>
          <li><strong>Full URL:</strong> {window.location.href}</li>
        </ul>
      </div>

      <div style={{ marginBottom: '1rem' }}>
        <strong>Facebook OAuth Configuration:</strong>
        <ul>
          <li><strong>App ID:</strong> {SOCIAL_MEDIA_CONFIG.facebook.appId}</li>
          <li><strong>Redirect URI:</strong> <code style={{ backgroundColor: '#e9ecef', padding: '2px 4px' }}>{redirectUri}</code></li>
        </ul>
      </div>

      <div style={{ marginBottom: '1rem' }}>
        <strong>Domain Detection:</strong>
        <ul>
          <li>Production BSO: {origin.includes('bigsystemone.com') ? '[YES]' : '[NO]'}</li>
          <li>Main Amplify: {origin.includes('main.d2h2cbbgz5s714.amplifyapp.com') ? '[YES]' : '[NO]'}</li>
          <li>Any Amplify: {origin.includes('amplifyapp.com') ? '[YES]' : '[NO]'}</li>
          <li>Localhost: {(origin.includes('localhost') || origin.includes('127.0.0.1')) ? '[YES]' : '[NO]'}</li>
        </ul>
      </div>

      <div style={{ 
        padding: '1rem', 
        backgroundColor: '#d1ecf1', 
        border: '1px solid #bee5eb',
        borderRadius: '4px',
        marginBottom: '1rem'
      }}>
        <strong>[REQUIRED] Facebook App Settings:</strong>
        <div style={{ marginTop: '0.5rem' }}>
          <strong>[CURRENT] DOMAIN TO ADD:</strong>
          <pre style={{ backgroundColor: '#fff3cd', border: '2px solid #ffc107', padding: '0.5rem', borderRadius: '4px', margin: '0.5rem 0', fontWeight: 'bold' }}>
            {window.location.hostname}
          </pre>
        </div>
        <div style={{ marginTop: '0.5rem' }}>
          <strong>App Domains (add this to Facebook):</strong>
          <pre style={{ backgroundColor: '#fff', padding: '0.5rem', borderRadius: '4px', margin: '0.5rem 0' }}>
{`bigsystemone.com
d2h2cbbgz5s714.amplifyapp.com
localhost`}
          </pre>
        </div>
        <div style={{ marginTop: '0.5rem' }}>
          <strong>[CURRENT] REDIRECT URI TO ADD:</strong>
          <pre style={{ backgroundColor: '#fff3cd', border: '2px solid #ffc107', padding: '0.5rem', borderRadius: '4px', margin: '0.5rem 0', fontWeight: 'bold' }}>
            {redirectUri}
          </pre>
        </div>
        <div style={{ marginTop: '0.5rem' }}>
          <strong>Valid OAuth Redirect URIs (add all to Facebook):</strong>
          <pre style={{ backgroundColor: '#fff', padding: '0.5rem', borderRadius: '4px', margin: '0.5rem 0' }}>
{`https://main.d2h2cbbgz5s714.amplifyapp.com/social-media/facebook-callback
https://bigsystemone.com/social-media/facebook-callback
http://localhost:3000/social-media/facebook-callback`}
          </pre>
        </div>
      </div>

      <div style={{ fontSize: '12px', color: '#6c757d' }}>
        [INFO] Check the browser console for additional debug information
      </div>
    </div>
  );
};